// extracted by mini-css-extract-plugin
export default {"title":"_45BM0","mobile":"XnGNd"};